import React from 'react';


const Dndholder = (props) => {

	return (
  <div className="form-group" >
    Holder
  </div>
)
}

export default Dndholder;
